<p>予約購入完了</p>
<button id="ssn-test-booking-completed" class="testButton" (click)="bookingCompletedTest1()">予約購入完了画面へ</button>
<button id="ssn-test-booking-completed2" class="testButton" (click)="bookingCompletedTestTicketed()">発券済み</button>
<button id="ssn-test-booking-completed3" class="testButton" (click)="bookingCompletedTestUnticketed()">未発券</button>
<button id="ssn-test-booking-completed4" class="testButton" (click)="bookingCompletedTestUnpurchased()">未購入</button>
<button id="ssn-test-booking-completed5" class="testButton" (click)="bookingCompletedTestAcceptedCv()">
  コンビニ支払
</button>
<button id="ssn-test-booking-completed6" class="testButton" (click)="bookingCompletedTestAcceptedIb()">
  ネットバンキング支払
</button>
